<script setup lang="ts">
import { useSettingsPageLineActivationUserVariableEditViewQuery } from './SettingsPageLineActivationUserVariableEditView.generated'
import { useRoute } from 'vue-router'
import SettingsPageLineActivationUserVariableEditForm from './SettingsPageLineActivationUserVariableEditForm.vue'
import SettingsPageLineActivationUserVariableDefinitionValueSelectOptionForm from './SettingsPageLineActivationUserVariableDefinitionValueSelectOptionForm.vue'
import SettingsPagePanel from '../SettingsPagePanel.vue'
import SettingsPagePanelHeader from '../SettingsPagePanelHeader.vue'
import { computed } from 'vue'
import BreadcrumbList from '@/components/molecules/BreadcrumbList.vue'

const route = useRoute('LineActivationSettingUserVariableEditView')
const guid = route.params.userVariableGuid

const pageQuery = useSettingsPageLineActivationUserVariableEditViewQuery(
  {
    guid: guid,
  },
  {
    fetchPolicy: 'no-cache',
  }
)

const userVariableDefinition = computed(() => {
  return pageQuery.result.value?.userVariableDefinition
})

const handleChanged = () => {
  // 変更が反映されないことがあったら DB のレプリカラグを疑う
  pageQuery.refetch()
}
</script>

<template>
  <div>
    <BreadcrumbList :links="route.meta.breadcrumbs" />
    <SettingsPagePanel :class="$style.panel">
      <SettingsPagePanelHeader>
        <template #title>カスタム項目</template>
      </SettingsPagePanelHeader>
      <SettingsPageLineActivationUserVariableEditForm
        v-if="userVariableDefinition"
        :user-variable-definition="userVariableDefinition"
        @changed="handleChanged"
      />
      <div
        v-if="
          userVariableDefinition &&
          (userVariableDefinition.value.__typename ===
            'UserVariableDefinitionValueSelect' ||
            userVariableDefinition.value.__typename ===
              'UserVariableDefinitionValueMultipleSelect')
        "
      >
        <hr :class="$style.hr" />
        <SettingsPageLineActivationUserVariableDefinitionValueSelectOptionForm
          :user-variable-definition-guid="userVariableDefinition.guid"
          :options="userVariableDefinition.value.options"
          @changed="handleChanged"
        />
      </div>
    </SettingsPagePanel>
  </div>
</template>

<style module lang="scss">
.panel {
  margin-top: 16px;
}

.hr {
  border: none;
  border-top: 1px solid $color-border-low-emphasis;
  margin: 32px 0;
}
</style>
